// Theme: titanium-dawn
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'titanium-dawn',
  name: 'TITANIUM DAWN',
  tagline: 'TITANIUM DAWN',
  description: 'Titanio aquecido com neutros quentes e leitura limpa.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#1A1814', '#252220', '#A8A29E', '#F5F5F4'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-mono theme-titanium-dawn'
  },
  colorVars: {
    '--accent': '#A8A29E',
    '--accent-foreground': '#1A1814',
    '--background': '#1A1814',
    '--border': '#302b24',
    '--card': '#252220',
    '--card-border-active': 'rgba(168, 162, 158, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F5F5F4',
    '--card-glow': 'rgba(168, 162, 158, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1814',
    '--foreground': '#F5F5F4',
    '--hold-fill': '#A8A29E',
    '--input': '#302b24',
    '--modal-bg': '#1A1814',
    '--modal-border': '#302b24',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#302b24',
    '--muted-foreground': '#E7E5E4',
    '--nav-active': '#A8A29E',
    '--nav-bg': '#252220',
    '--popover': '#252220',
    '--popover-foreground': '#F5F5F4',
    '--primary': '#A8A29E',
    '--primary-foreground': '#1A1814',
    '--ring': '#A8A29E',
    '--secondary': '#302b24',
    '--secondary-foreground': '#F5F5F4',
    '--streak': '#A8A29E',
    '--success': '#22c55e',
    '--success-foreground': '#1A1814',
    '--xp': '#A8A29E',
    '--xp-bg': '#252220'
  },
  resolvedVars: {
    '--accent': '#A8A29E',
    '--accent-foreground': '#1A1814',
    '--accent-foreground-hsl': '40 13% 9%',
    '--accent-foreground-oklch': 'from #1A1814 l c h',
    '--accent-hsl': '24 5% 64%',
    '--accent-oklch': 'from #A8A29E l c h',
    '--background': '#1A1814',
    '--background-hsl': '40 13% 9%',
    '--background-oklch': 'from #1A1814 l c h',
    '--border': '#302b24',
    '--border-hsl': '35 14% 16%',
    '--border-oklch': 'from #302b24 l c h',
    '--border-w': '1px',
    '--card': '#252220',
    '--card-border-active': 'rgba(168, 162, 158, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F5F5F4',
    '--card-foreground-hsl': '60 5% 96%',
    '--card-foreground-oklch': 'from #F5F5F4 l c h',
    '--card-glow': 'rgba(168, 162, 158, 0.03)',
    '--card-hsl': '24 7% 14%',
    '--card-oklch': 'from #252220 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1814',
    '--destructive-foreground-hsl': '40 13% 9%',
    '--destructive-foreground-oklch': 'from #1A1814 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F5F5F4',
    '--foreground-hsl': '60 5% 96%',
    '--foreground-oklch': 'from #F5F5F4 l c h',
    '--hold-fill': '#A8A29E',
    '--hold-fill-hsl': '24 5% 64%',
    '--hold-fill-oklch': 'from #A8A29E l c h',
    '--input': '#302b24',
    '--input-hsl': '35 14% 16%',
    '--input-oklch': 'from #302b24 l c h',
    '--modal-bg': '#1A1814',
    '--modal-bg-hsl': '40 13% 9%',
    '--modal-bg-oklch': 'from #1A1814 l c h',
    '--modal-border': '#302b24',
    '--modal-border-hsl': '35 14% 16%',
    '--modal-border-oklch': 'from #302b24 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#302b24',
    '--muted-foreground': '#E7E5E4',
    '--muted-foreground-hsl': '20 6% 90%',
    '--muted-foreground-oklch': 'from #E7E5E4 l c h',
    '--muted-hsl': '35 14% 16%',
    '--muted-oklch': 'from #302b24 l c h',
    '--nav-active': '#A8A29E',
    '--nav-active-hsl': '24 5% 64%',
    '--nav-active-oklch': 'from #A8A29E l c h',
    '--nav-bg': '#252220',
    '--nav-bg-hsl': '24 7% 14%',
    '--nav-bg-oklch': 'from #252220 l c h',
    '--popover': '#252220',
    '--popover-foreground': '#F5F5F4',
    '--popover-foreground-hsl': '60 5% 96%',
    '--popover-foreground-oklch': 'from #F5F5F4 l c h',
    '--popover-hsl': '24 7% 14%',
    '--popover-oklch': 'from #252220 l c h',
    '--primary': '#A8A29E',
    '--primary-foreground': '#1A1814',
    '--primary-foreground-hsl': '40 13% 9%',
    '--primary-foreground-oklch': 'from #1A1814 l c h',
    '--primary-hsl': '24 5% 64%',
    '--primary-oklch': 'from #A8A29E l c h',
    '--radius': '14px',
    '--ring': '#A8A29E',
    '--ring-hsl': '24 5% 64%',
    '--ring-oklch': 'from #A8A29E l c h',
    '--secondary': '#302b24',
    '--secondary-foreground': '#F5F5F4',
    '--secondary-foreground-hsl': '60 5% 96%',
    '--secondary-foreground-oklch': 'from #F5F5F4 l c h',
    '--secondary-hsl': '35 14% 16%',
    '--secondary-oklch': 'from #302b24 l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#A8A29E',
    '--streak-hsl': '24 5% 64%',
    '--streak-oklch': 'from #A8A29E l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1814',
    '--success-foreground-hsl': '40 13% 9%',
    '--success-foreground-oklch': 'from #1A1814 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(24 5% 64% / 0.15)',
    '--xp': '#A8A29E',
    '--xp-bg': '#252220',
    '--xp-bg-hsl': '24 7% 14%',
    '--xp-bg-oklch': 'from #252220 l c h',
    '--xp-hsl': '24 5% 64%',
    '--xp-oklch': 'from #A8A29E l c h'
  }
}
